export const GET_DoctorUsers = "GET_DoctorUsers";
